<template>
  <button v-if="!asSpan" :class="classes" @click="$emit('click')">
    <span class="commonButton__content">
      <Icon v-if="iconName" :name="iconName" />
      <slot /></span>
  </button>
  <span v-else :class="classes" @click="$emit('click')">
    <span class="commonButton__content">
      <Icon v-if="iconName" :name="iconName" />
      <slot /></span>
  </span>
</template>

<script>
import Icon from '@/components/common/Icon/Icon'

export default {
  components: {
    Icon
  },
  props: {
    asSpan: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => {
        return ['small', 'medium'].includes(value)
      }
    },
    variant: {
      type: String,
      default: 'gradient',
      validator: (value) => {
        return ['gradient', 'purple', 'dark-purple', 'white', 'dark', 'transparent'].includes(value)
      }
    },
    iconName: {
      type: String,
      default: null
    },
    isFullWidthOnMobile: {
      type: Boolean,
      default: false
    },
    isFullWidth: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: false
    },
    borderRadius: {
      type: String,
      default: 'medium',
      validator: (value) => {
        return ['large', 'medium'].includes(value)
      }
    }
  },
  computed: {
    classes () {
      return [
        'commonButton',
        `commonButton_${this.variant}`,
        `commonButton_${this.size}`,
        `commonButton_br-${this.borderRadius}`,
        {
          commonButton_fullWidthMobile: this.isFullWidthOnMobile,
          commonButton_fullWidth: this.isFullWidth,
          commonButton_border: this.hasBorder
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.commonButton {
  position: relative;
  border: 0;
  display: inline-block;
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  outline: none;
  text-align: center;
  cursor: pointer;
  width: fit-content;

  &:disabled {
    pointer-events: none;
  }

  &_br-medium {
    border-radius: 4px;
  }

  &_br-large {
    border-radius: 8px;
  }

  &_gradient {
    background: linear-gradient(130.92deg, #f87900 -0.63%, #fe4f45 58%, #e419ba 114.33%);
    color: #fff;

    &:hover {
      background: linear-gradient(130.92deg, #da700b -0.63%, #ec5f57 58%, #d726b2 114.33%);
    }

    &:disabled {
      color: #8c8c8c;
      background: linear-gradient(130.92deg, #8c4400 -0.63%, #8c2c26 58%, #8c0f72 114.33%);
    }
  }

  &_purple {
    background: $colorLightPurple;
    color: $colorLight;
  }

  &_dark-purple {
    background: $colorPurple;
    color: $colorLight;
  }

  &_white {
    background: $colorLight;
    color: $colorDark;
  }

  &_transparent {
    background: rgba(#1C0C3259, 0.35);
    color: $colorLight;

    &.commonButton_border {
      border: 1px solid $colorLight;
    }
  }

  &_dark {
    background: $colorDarkPrimary;
    color: $colorLight;

    &.commonButton_border {
      border: 1px solid #605570;

      &:hover {
        transition: all 0.2s ease;
        border: 1px solid #fff;
      }
    }
  }

  &_small {
    padding: $gap * 0.5 $gap * 1.5;
  }

  &_medium {
    padding: $gap * 0.75 $gap * 1.5;
  }

  &_fullWidth {
    width: 100%;
  }

  &_fullWidthMobile {
    @include display-less(desktop) {
      width: 100%;
    }
  }

  &__content {
    display: flex;
    flex-direction: row;
    gap: $gap * 0.5;
    align-items: center;
    justify-content: center;
  }
}
</style>
